import { Button as ButtonANTD, ButtonProps } from 'antd';

interface IProps extends ButtonProps {
  'aria-label'?: string;
}

export const Button: React.FC<IProps> = (props) => {
  const { 'aria-label': ariaLabel, disabled, children, ...restProps } = props;

  return (
    <ButtonANTD
      aria-label={ariaLabel} // use when button is only icon
      aria-disabled={disabled}
      disabled={disabled}
      {...restProps}
    >
      {children}
    </ButtonANTD>
  );
};
